/* 同步操作的数据 */
import * as types from './mutation-types'
export default {
  [types.SET_WFFLAG](state, obj) {
    state.wfFlag = obj
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js